export default __webpack_public_path__ + "static/media/1904.a63ac7e3.png";